








import { Vue, Component, Prop } from 'vue-property-decorator'
import Icon from '../../shared/Icon/Icon.vue'

@Component({
  components: {
    Icon
  }
})
export default class PrimaryButton extends Vue {
  @Prop({ required: true }) iconName!: string
  @Prop({ default: 'normal' }) state!: 'normal' | 'selected'

  customCss = {
    transform: 'rotate(-90deg)',
    'padding-left': '2px'
  }
}
